export default {"src":"/_next/static/media/daily.2511357c.svg","height":39,"width":183};